<template>
  <div v-if="subcategories.length > 0" class="form-row">
    <select v-model="programFilter" required>
      <option value="" disabled>Select your program category</option>
      <option v-for="sub in subcategories" :key="sub" :value="sub">{{ sub }}</option>
    </select>
  </div>

  <div class="form-row">
    <ProgramSelect v-model:selected="selectedProgram" :data="programsLabels" :is-icon="false" placeholder="Select your program" @update-id="$emit('update:programId', $event)" />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import ProgramSelect from "./common/ProgramSelect.vue";
import useApi from "../utils/apiCalls.js";

const props = defineProps({
  category: {
    type: String,
    required: true,
  },
  programId: {
    type: [String, Number],
    default: "",
  },
});

const emit = defineEmits(["update:programId"]);
const { apiGetRequest } = useApi();

const programs = ref([]);
const programFilter = ref("");
const selectedProgram = ref("");

const programSubs = p => [p.category_sub_1, p.category_sub_2, p.category_sub_3].filter(Boolean);

const subcategories = computed(() => {
  const hasNullCategory = programs.value.some(p => programSubs(p).length === 0);
  const subs = [...new Set(programs.value.flatMap(p => programSubs(p)))];
  const sorted = subs.sort();
  if (hasNullCategory && subs.length > 0) {
    sorted.push("Other");
  }
  return sorted;
});

const programsLabels = computed(() => {
  return programs.value
    .filter(p => {
      if (programFilter.value) {
        if (programFilter.value === "Other") {
          return programSubs(p).length === 0;
        }
        return programSubs(p).includes(programFilter.value);
      }
      return true;
    })
    .map(p => ({ id: p.id, label: p.full_program_name }));
});

onMounted(async () => {
  try {
    const data = await apiGetRequest({ path: `/events/${props.category}` });
    if (data) {
      programs.value = data.events || data;
    }
  } catch {
    // Error loading programs - silently fail
  }
});

watch(programFilter, () => {
  selectedProgram.value = "";
  emit("update:programId", null);
});

watch(
  [() => props.programId, programs],
  ([val, loadedPrograms]) => {
    if (val && loadedPrograms.length) {
      const program = loadedPrograms.find(p => p.id === val);
      if (program) {
        selectedProgram.value = { id: program.id, label: program.full_program_name };
      }
    }
  },
  { immediate: true }
);
</script>
